import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getVideosByType } from "@/utils/video";

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-8">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            分类快捷入口
          </h2>
          <p className="mt-1 text-sm text-foreground-500">
            按类别快速进入，发现属于你的下一部好剧
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((category) => (
          <Link
            key={category.type}
            to={`/category/${category.type}`}
            className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300"
          >
            <div className="flex items-start justify-between">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-background-50 transition-colors group-hover:bg-accent-500">
                <i className={`${category.icon} text-2xl`}></i>
              </span>
              <i className="ri-arrow-right-up-line text-xl text-foreground-300 transition-colors group-hover:text-accent-500"></i>
            </div>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
              {category.name}
            </h3>
            <p className="mt-1 text-sm font-medium text-accent-600">
              {category.tagline}
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-500">
              {category.description}
            </p>
            <div className="mt-5 flex items-center gap-2 border-t border-background-100 pt-4 text-xs text-foreground-500">
              <i className="ri-stack-line text-base text-secondary-500"></i>
              共 {getVideosByType(category.type).length} 部资源
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}